import {
  Box,
  Button,
  Center,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { Component } from "react";

import { Overlay } from "../../Overlay/Overlay";
import { IoCall } from "react-icons/all";

interface CancelBookingProps {
  title: string;
  closeDialog: Function;
  reviseBooking: Function;
  cancelEstimateBooking: Function;
}

interface CancelBookingState {
  reason: string;
  isReasonFilled: boolean;
}

export default class CancelBooking extends Component<
  CancelBookingProps,
  CancelBookingState
> {
  constructor(props: CancelBookingProps) {
    super(props);
    this.state = {
      reason: "",
      isReasonFilled: false,
    };
  }
  handleReasonChange = (e: any) => {
    const reason = e.currentTarget.value;
    this.setState({
      reason,
      isReasonFilled: reason.trim() !== "",
    });
  };
  render() {
    return (
      <Overlay isMenuOverlay={false} isDialogOverlay={true}>
        <Center className="defaultBG">
          <Box
            maxW={["sm", null, "4xl"]}
            p={12}
            bg="white"
            boxShadow="lg"
            m="auto"
            borderRadius="md"
          >
            <Heading color="blue.700">{this.props.title}</Heading>
            <Text
              fontSize="xl"
              fontWeight={"bold"}
              color={"blue.700"}
              textTransform={"uppercase"}
              mb={4}
              mt={4}
            >
              You have the option to revise the booking
            </Text>
            <Button
              w="100%"
              className="mx-0"
              colorScheme={"blue"}
              variant="outline"
              onClick={() => this.props.reviseBooking()}
            >
              Revise Booking
            </Button>
            <a href="tel:0733543711" className="no-underline">
              <Button
                colorScheme="cyan"
                className="mx-0 flex-wrap"
                bg="cyan.300"
                w="100%"
                mt={6}
                height={"100%"}
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                p={4}
              >
                <span className="btnText mx-1 whitespace-normal break-words text-center no-underline">
                  0733543711
                </span>
                <IoCall className="mx-2" />
                <span className="btnText whitespace-normal break-words text-center no-underline">
                  Call for assistance before canceling
                </span>
              </Button>
            </a>

            <FormControl mt={4}>
              <FormLabel>Please enter a reason before canceling</FormLabel>
              <Input
                style={{ borderColor: "black" }}
                value={this.state.reason}
                onChange={this.handleReasonChange}
              />
            </FormControl>

            <Button
              w="40%"
              colorScheme={"blue"}
              variant="outline"
              onClick={() => this.props.closeDialog()}
            >
              Close
            </Button>
            <Button
              w="40%"
              colorScheme={"red"}
              variant="outline"
              disabled={!this.state.isReasonFilled}
              onClick={() =>
                this.props.cancelEstimateBooking(this.state.reason)
              }
            >
              Cancel Booking
            </Button>
          </Box>
        </Center>
      </Overlay>
    );
  }
}
